export const urlsToAddDemoSolitxUrl: string[] = [
    '/SolitxProfile',
    '/PaymentService',
    '/ProductService',
    '/ContractService',
    '/BusinessEventService',
    '/TransactionService',
    '/MarketService',
    '/LedgerService'
];
